import React from 'react';
import useIcons from '../../../../../hooks/use-icon';
import styles from './ReportCategoryItem.module.scss';

const ReportCategoryItem = ({
	icon,
	title,
	onClick,
	reportIndex,
	reportId,
	reportName,
	handleGenerateReport,
	handleViewReport,
}) => {
	const Icon = useIcons(icon);

	return (
		<div
			className={styles.category_item_wrapper}
			onClick={() => handleViewReport(reportId, reportIndex, reportName)}
		>
			<div className={styles.item_content}>
				<Icon />
				<div className={styles.item_title}>{title}</div>
			</div>

			{/* <div className={styles.action_buttons}>
				<div
					className={styles.action_item}
					onClick={() =>
						handleViewReport(reportId, reportIndex, reportName)
					}
				>
					View
				</div>
				<div
					className={styles.action_item}
					onClick={() =>
						handleGenerateReport(reportId, reportIndex, reportName)
					}
				>
					Create
				</div>
			</div> */}
		</div>
	);
};

export default ReportCategoryItem;
